const buttonTypes = ['first', 'last', 'next', 'previous'];

export { buttonTypes };
